<template>
	<section style="padding:15px;">
		<div v-if="roleRules.STUDENT_INFO_FLG === 'Y' && Object.keys(selectedStudent).length > 0">
			<h2>{{ selectedStudent.NAME }} ({{ selectedStudent.STUDENT_ID }})</h2>

			<div v-for="(school, index) in studentInformation" :key="`${school.ENROLLMENT.SCHOOL_ID}_${index}`">
				<h4>
					<strong v-if="school.ENROLLMENT.STATUS_FLG === 'N'">
						{{ $t('MAIN_CONTENT.StudentInformation.sideMenuGradeLabelNotEnrolled', { school: school.ENROLLMENT.SCHOOL_TITLE, grade: school.ENROLLMENT.GRADE_LEVEL }) }}
					</strong>
					<strong v-else>
						{{ $t('MAIN_CONTENT.StudentInformation.sideMenuGradeLabelEnrolled', { school: school.ENROLLMENT.SCHOOL_TITLE, grade: school.ENROLLMENT.GRADE_LEVEL }) }}
					</strong>
				</h4>
				<br />

				<!-- Start of Counselor data -->
				<template v-if="showCounselorData(school)">
					<hr />
					<div class="row">
						<div class="col-sm-4">
							<strong>
								{{ $t('MAIN_CONTENT.StudentInformation.counselorWithColon') }}
							</strong>
							<br />
							{{ school.ENROLLMENT.COUNSELOR_NAME }}
						</div>
					</div>
				</template>
				<!-- End of Counselor data -->
				<hr />
				<div class="row">
					<!-- Start of Homeroom data -->
					<template showHomeroomData(school)>
						<div class="col-sm-4" v-if="!!school.ENROLLMENT.HOME_ROOM">
							<strong>
								{{ $t('MAIN_CONTENT.StudentInformation.homeroomWithColon') }}
							</strong>
							<br />
							{{ school.ENROLLMENT.HOME_ROOM }}
						</div>
						<div class="col-sm-4" v-if="!!school.ENROLLMENT.STAFF_NAME">
							<strong>
								{{ $t('MAIN_CONTENT.StudentInformation.teacherWithColon') }}
							</strong>
							<br />
							{{ school.ENROLLMENT.STAFF_NAME }}
						</div>
					</template>
					<div class="col-sm-4"
								v-if="!!school.ENROLLMENT.TEAM_DESC && roleRules.STUDENT_INFO_TEAM_FLG === 'Y'">
						<strong>
							{{ $t('MAIN_CONTENT.StudentInformation.team') }}
						</strong>
						<br />
						{{ school.ENROLLMENT.TEAM_DESC }}
					</div>
					<div class="col-sm-4"
								>
						<strong>
							{{ $t('MAIN_CONTENT.StudentInformation.learningGroup') }}
						</strong>
						<br />
						{{ school.ENROLLMENT.LEARNING_GROUP_DESC }}
					</div>
				</div>
				<!-- End of Homeroom data -->

				<!-- Start of Locker data -->
				<template v-if="showLockerData(school)">
					<hr />
					<div class="row">
						<div class="col-sm-4" v-if="!!school.ENROLLMENT.LOCKER_NO">
							<strong>
								{{ $t('MAIN_CONTENT.StudentInformation.lockerWithColon') }}
							</strong>
							<br />
							{{ school.ENROLLMENT.LOCKER_NO }}
						</div>
						<div class="col-sm-4" v-if="!!school.ENROLLMENT.LOCKER_LOCATION">
							<strong>
								{{ $t('MAIN_CONTENT.StudentInformation.locationWithColon') }}
							</strong>
							<br />
							{{ school.ENROLLMENT.LOCKER_LOCATION }}
						</div>
						<div class="col-sm-4"
								 v-if="!!school.ENROLLMENT.LOCKER_COMBINATION && roleRules.STUDENT_INFO_LOCKER_COMB_FLG === 'Y'">
							<strong>
								{{ $t('MAIN_CONTENT.StudentInformation.combinationWithColon') }}
							</strong>
							<br />
							{{ school.ENROLLMENT.LOCKER_COMBINATION }}
						</div>
					</div>
				</template>
				<!-- End of Locker data -->

				<!-- Start of Busing Data -->
				<busing-details v-if="showBusingDetails(school.TRANSPORTATION)"
												:busingDetails="school.TRANSPORTATION"
												:busPeriods="getBusingPeriods(school.TRANSPORTATION)">
				</busing-details>
				<!-- End of Busing Data -->

				<!-- Start of Building data and Admin Info -->
				<building-information v-if="showBuildingInfo(school)"
															:buildingInformation="school.SCHOOL"
															:adminInfo="school.ADMINISTRATORS">
				</building-information>
				<!-- End of Building data and Admin Info -->
				<br />
			</div>
		</div>
		<div v-if="Object.keys(selectedStudent).length === 0">
			{{ $t('MAIN_CONTENT.commonContent.noStudentHasBeenSelectedWithPeriod') }}
		</div>
	</section>
</template>

<script>
	import { mapGetters } from 'vuex';
	import BusingDetails from './BusingDetails.vue';
	import BuildingInformation from './BuildingInformation.vue';
	import StudentInformation from '../../api/StudentInformation';

	export default {
		name:				"StudentInformation",
		data() {
			return {
				studentInformation: []
			};
		},
		computed: {
			...mapGetters(['selectedStudent', 'role', 'roleRules'])
		},
		components:	{
			BusingDetails,
			BuildingInformation
		},
		methods: {
			loadStudentInformation() {
				const self = this;

				let studentInfo = new StudentInformation({
					routeParams: {
						student_rid: self.selectedStudent.STUDENT_RID
					}
				});

				if(this.role === 'admin') {
					studentInfo.query = {
						role_code: this.role
					}
				}

				studentInfo.get().then(response => {
					self.$set(self, 'studentInformation', response.data.data);
				})
				.catch(error => {
					console.log(error);
				});
			},
			showBuildingInfo(school) {
				return Object.keys(school.SCHOOL).length > 0 || school.ADMINISTRATORS.length > 0;
			},
			showBusingDetails(busingDetails) {
				return Object.keys(busingDetails).length > 0 &&
							 this.roleRules.STUDENT_INFO_TRANS_FLG === 'Y' &&
							 !this.isNotRestricted();
			},
			showCounselorData(school) {
				let showData = false;

				if(Object.keys(school.ENROLLMENT).length > 0) {
					if(!!school.ENROLLMENT.COUNSELOR_NAME) {
						showData = true;
					}
				}

				return showData && this.roleRules.STUDENT_INFO_COUNSELOR_FLG === 'Y';
			},
			showHomeroomData(school) {
				return (!!school.ENROLLMENT.HOME_ROOM || !!school.ENROLLMENT.STAFF_NAME) &&
								this.roleRules.STUDENT_INFO_HOMEROOM_FLG === 'Y';
			},
			showLockerData(school) {
				return (!!school.ENROLLMENT.LOCKER_NO ||
							 !!school.ENROLLMENT.LOCKER_LOCATION ||
							 !!school.ENROLLMENT.LOCKER_COMBINATION) && this.roleRules.STUDENT_INFO_LOCKER_FLG === 'Y';
			},
			isNotRestricted() {
				let restricted = false;

				if(this.role !== 'parent') {
					if(!!this.roleRules.RESTRICTED_ACCOUNT_FLG) {
						if(this.roleRules.RESTRICTED_ACCOUNT_FLG === 'Y') {
							restricted = true;
						}
					}
				}

				return restricted;
			},
			getBusingPeriods(busData) {
				let periods = [];

				if(this.showBusingDetails) {
					if(
						!!busData.AM_BUS_NUMBER_1 ||
						!!busData.AM_BUS_NUMBER_2 ||
						!!busData.AM_BUS_NUMBER_3 ||
						!!busData.AM_STOP_LOCATION_1 ||
						!!busData.AM_STOP_LOCATION_2 ||
						!!busData.AM_STOP_LOCATION_3 ||
						!!busData.AM_STOP_TIME_1 ||
						!!busData.AM_STOP_TIME_2 ||
						!!busData.AM_STOP_TIME_3
					) {
						periods.push('AM');
					}

					if(
						!!busData.PM_BUS_NUMBER_1 ||
						!!busData.PM_BUS_NUMBER_2 ||
						!!busData.PM_BUS_NUMBER_3 ||
						!!busData.PM_STOP_LOCATION_1 ||
						!!busData.PM_STOP_LOCATION_2 ||
						!!busData.PM_STOP_LOCATION_3 ||
						!!busData.PM_STOP_TIME_1 ||
						!!busData.PM_STOP_TIME_2 ||
						!!busData.PM_STOP_TIME_3
					) {
						periods.push('PM');
					}
				}

				return periods;
			}
		},
		created() {
			this.$store.commit('setTitleIcon', 'book-reader');
			this.$store.commit('setTitle', 'MAIN_CONTENT.StudentInformation.sideMenuStudentInformationLink');
			this.$store.commit('setUseHeader', true);

			if(this.roleRules.STUDENT_INFO_FLG === 'Y' && Object.keys(this.selectedStudent).length > 0) {
				this.loadStudentInformation();
			} else {
				this.$router.push({ name: 'HomePage' });
			}
		}
	};
</script>
